import { css, styled } from 'styled-components';
import { palette } from '@/constants/styles';
import editIcon from './assets/edit.svg';
import deleteIcon from './assets/delete.svg';

export const ItemsCount = styled.div`
	margin-bottom: 16px;
	font-size: 14px;
	color: ${palette.lightGray};
`;

export const ItemsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
	gap: 16px;
	width: 100%;
`;

export const Item = styled.div<{ $isSelected: boolean }>`
	position: relative;
	aspect-ratio: 1/1;
	cursor: pointer;
	border-radius: 12px;
	overflow: hidden;
	background: ${palette.primaryGray};
	border: 1px solid ${palette.lightGray};

	${({ $isSelected }) =>
		$isSelected &&
		css`
			border: 2px solid #000;
		`}

	img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	div {
		display: none;
		flex-direction: column;
		gap: 10px;
		position: absolute;
		right: 16px;
		bottom: 16px;
	}

	&:hover div {
		display: flex;
	}
`;

export const EditItemButton = styled.button`
	width: 40px;
	height: 40px;
	/* prettier-ignore */
	background: black url("${editIcon}") no-repeat center;
	border: none;
	border-radius: 50%;
	cursor: pointer;
`;

export const DeleteItemButton = styled(EditItemButton)`
	/* prettier-ignore */
	background-image: url("${deleteIcon}");
`;
